import { render, staticRenderFns } from "./PmtaServerBalancers.vue?vue&type=template&id=3e528fa5&scoped=true"
import script from "./PmtaServerBalancers.vue?vue&type=script&lang=js"
export * from "./PmtaServerBalancers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e528fa5",
  null
  
)

export default component.exports